<template>
    <div>
        <a-form ref="formItem" :model="form" :colon="false" layout="inline" class="form">
            <div class="form-row">
                <a-row type="flex" justify="start">
                    <a-col v-for="item in filedsList" :key="item.name" class="itemCol" :span="spanCol">
                        <a-form-item :key="item.name" class="search_item">
                            <span slot="label">
                                <template v-if="item.label.length < 8">{{ item.label }}</template>
                                <a-tooltip v-else placement="bottom">
                                    <template slot="title">
                                        <span>{{ item.label }}</span>
                                    </template>
                                    <span>{{ `${item.label.substring(0, 7)}...` }}</span>
                                </a-tooltip>
                            </span>
                            <template v-if="item.custom">
                                <slot :name="item.name"></slot>
                            </template>
                            <component :is="componentType[item.type]" v-else-if="item.type === 'input'" v-model.trim="form[item.name]" v-bind="item.prop" @pressEnter="getData()" />
                            <component
                                :is="componentType[item.type]"
                                v-else-if="item.type === 'selectDom'"
                                v-model="form[item.name]"
                                v-bind="item.prop"
                                @onSearch="onSearchProject"
                                @checkedList="checkedList"
                            />
                            <component :is="componentType[item.type]" v-else-if="item.type === 'carrier'" v-bind="item.prop" @change="handleChangeCarrier()" />
                            <component :is="componentType[item.type]" v-else-if="item.type === 'cascaderCarrier'" v-bind="item.prop" @change="handleWhChange" />
                            <component :is="componentType[item.type]" v-else-if="item.type === 'date'" v-model="form[item.name]" v-bind="item.prop" @change="handleChange()">
                                <template #suffixIcon>
                                    <a-icon type="calendar" />
                                </template>
                            </component>
                            <component :is="componentType[item.type]" v-else v-model="form[item.name]" v-bind="item.prop" @change="handleChange()" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="spanCol" class="active_bar">
                        <div :class="[fileds.length < quantity ? 'three_item' : 'search-btn']">
                            <div v-if="fileds.length > quantity - 1" class="moreData" @click="openMore = !openMore">
                                <span class="text">{{ !openMore ? '展开筛选' : '收起筛选' }}</span>
                                <a-icon v-if="!openMore" type="caret-down" />
                                <a-icon v-else class="caret-up-style" type="caret-up" />
                            </div>
                            <div class="form-btns">
                                <a-button class="form-btn" @click="handleReset">重置</a-button>
                                <a-button class="form-btn" type="primary" @click="getData(true)">查询</a-button>
                            </div>
                        </div>
                    </a-col>
                </a-row>
            </div>
        </a-form>
    </div>
</template>

<script>
import { formatNullData } from '@/utils/util';
import SelectDom from '../select/SelectDom.vue';
import selectCarrier from '../selectCarrier/serviceSelect.vue';
import cascaderCarrier from '../cascaderSelect';

const componentType = {
    input: 'a-input',
    select: 'a-select',
    date: 'a-range-picker',
    selectDom: 'SelectDom',
    carrier: 'selectCarrier',
    cascaderCarrier: 'cascaderCarrier'
};
// 不同尺寸所对应的页面宽度和每行 item 个数
const DifferentSizeData = [
    { width: 1920, quantity: 4, spanCol: 6 },
    { width: 1200, quantity: 4, spanCol: 6 },
    { width: 768, quantity: 2, spanCol: 12 },
    { width: 0, quantity: 1, spanCol: 24 }
];
export default {
    components: {
        SelectDom,
        selectCarrier,
        cascaderCarrier
    },
    props: {
        form: {
            type: Object,
            default: () => {}
        },
        fileds: {
            type: Array,
            default: () => []
        },
        open: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            openMore: false,
            componentType,
            quantity: 4,
            spanCol: 6,
            filedsList: []
        };
    },
    watch: {
        openMore: {
            handler() {
                if (!this.openMore) {
                    this.filedsList = this.fileds.slice(0, this.quantity - 1);
                } else {
                    this.filedsList = [...this.fileds];
                }
            },
            immediate: true
        },
        fileds() {
            this.filedsList = this.fileds.length > this.quantity ? this.fileds.slice(0, this.quantity - 1) : [...this.fileds];
            if (!this.openMore) {
                this.filedsList = this.fileds.slice(0, this.quantity - 1);
            } else {
                this.filedsList = [...this.fileds];
            }
        },
        quantity() {
            if (!this.openMore) {
                this.filedsList = this.fileds.slice(0, this.quantity - 1);
            }
        }
    },
    created() {
        window.addEventListener('resize', this.getPerLineItemQuantity);
        this.getPerLineItemQuantity();
        this.filedsList = this.fileds.slice(0, this.quantity - 1);
        this.openMore = this.open;
    },
    methods: {
        getPerLineItemQuantity() {
            const documentScrollWidth = document.documentElement.scrollWidth;
            if (documentScrollWidth !== 0) {
                const size = DifferentSizeData.find((item) => documentScrollWidth >= item.width);
                this.quantity = size.quantity;
                this.spanCol = size.spanCol;
            }
        },
        handleReset() {
            this.$emit('reset');
        },
        handleChange() {
            this.getData();
        },
        handleChangeCarrier() {
            this.getData();
        },
        handleWhChange(data) {
            this.$emit('WhChange', data);
        },
        getData() {
            this.$emit('search', formatNullData(this.form));
        },
        onSearchProject(tenantName) {
            this.$emit('onSearch', tenantName);
        },
        checkedList(data) {
            this.$emit('checkedList', data);
        }
    }
};
</script>

<style lang="less" scoped>
.search_item {
    width: 100%;
    margin-bottom: 20px;

    /deep/.ant-form-item-label {
        width: 120px;
        margin-right: 6px;

        label {
            color: #606266;
        }
    }

    /deep/.ant-form-item-control-wrapper {
        width: calc(100% - 146px);
        margin-right: 20px;

        input {
            color: #171717;
        }
    }
}

.search-btn {
    margin-bottom: 20px;
    text-align: right;
    display: flex;
    justify-content: flex-end;
}

.moreData {
    height: 30px;
    line-height: 50px;
    background-color: #fff;
    font-size: 14px;
    color: #606266;
    display: flex;
    align-items: center;
    margin-top: 4px;

    &:hover {
        cursor: pointer;
    }

    .text {
        margin-right: 4px;
    }

    .caret-up-style {
        color: #06b880;
    }
}

.form-btns {
    display: flex;
    justify-content: flex-end;
    margin-right: 0;
    margin-top: 4px;
}

.form-btn {
    margin-left: 20px;
}

.form {
    /deep/.ant-form-item-label label {
        color: #606266;
    }

    /deep/ .ant-form-item-control-wrapper input {
        color: #171717 !important;
    }

    /deep/.ant-calendar-picker {
        width: 100% !important;
    }
}

.search_btn {
    color: #06b880;
    border-color: #06b880;
}

.active_bar {
    flex: 1;
    margin-right: 20px;
}

.three_item {
    text-align: right;
    display: flex;
    justify-content: flex-end;
}
</style>
